/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ApprovalDecisionComment } from './approvalDecisionComment';

export interface ApprovalDecision {
  comment?: ApprovalDecisionComment;
}
